/**
 * Launches the check deposit process in the native app.
 *
 * @param {object} options - The options for launching the check deposit.
 * @param {string} options.unitAccountId - The ID of the unit account.
 * @param {string} options.customerToken - The customer token.
 * @param {string} options.redirectUrl - The redirect URL.
 * @throws {Error} Throws an error if launchCheckDeposit is not available in the webview.
 */
export const launchCheckDepositWithNativeApp = ({ unitAccountId, customerToken, redirectUrl }) => {
  const { launchCheckDeposit } = window.NativeApp || {};

  if (typeof launchCheckDeposit === 'function') {
    launchCheckDeposit(unitAccountId, customerToken, redirectUrl);
  } else {
    throw new Error(`Cannot init launchCheckDeposit in webview at redirectURL: ${redirectUrl}`);
  }
};
